/* eslint-disable import/prefer-default-export */
export const LOGIN_REQUEST = 'profile/LOGIN_REQUEST';
